import React, { useState, useEffect, useCallback } from 'react';
import { Spinner } from 'react-bootstrap';
import notificacionPreferenciaService from '../services/notificacionPreferenciaService';
import PageHeader from '../components/ui/PageHeader';
import '../style/pages/HomePage.css';

const ConfiguracionNotificacionesPage = () => {
    const [tipos, setTipos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [guardando, setGuardando] = useState('');

    const cargar = useCallback(async () => {
        setLoading(true);
        setError('');
        try {
            const { data } = await notificacionPreferenciaService.listar();
            setTipos(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error('Error al cargar preferencias de notificaciones:', err);
            setError('No se pudieron cargar tus preferencias de notificaciones.');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        cargar();
    }, [cargar]);

    const toggle = async (tipo) => {
        const actual = tipos.find((t) => t.tipo === tipo);
        if (!actual || guardando) return;
        const nuevoValor = !actual.habilitado;

        setTipos((prev) => prev.map((t) => (t.tipo === tipo ? { ...t, habilitado: nuevoValor } : t)));
        setGuardando(tipo);
        try {
            await notificacionPreferenciaService.actualizar(tipo, nuevoValor);
        } catch (err) {
            console.error('Error al actualizar la preferencia de notificación:', err);
            // Revierte en caso de error: la UI no puede quedar mostrando algo que no se guardó.
            setTipos((prev) => prev.map((t) => (t.tipo === tipo ? { ...t, habilitado: !nuevoValor } : t)));
        } finally {
            setGuardando('');
        }
    };

    // Agrupar por canal
    const tiposInApp = tipos.filter(t => t.canal === 'IN_APP');
    const tiposEmail = tipos.filter(t => t.canal === 'EMAIL');

    return (
        <div className="homepage-container area-admin">
            <PageHeader
                variante="plano"
                icono="bell"
                titulo="Mis notificaciones"
                descripcion="Elegí qué avisos del sistema querés recibir y configurá los envíos globales si sos Administrador."
            />

            <div className="eventos-section">
                {error && (
                    <div className="empty-state-eventos">
                        <i className="bi bi-exclamation-triangle"></i>
                        <h5>Ocurrió un error</h5>
                        <p>{error}</p>
                    </div>
                )}

                {!error && (loading ? (
                    <div className="loading-state">
                        <Spinner animation="border" variant="primary" />
                        <p className="mt-3">Cargando preferencias...</p>
                    </div>
                ) : tipos.length === 0 ? (
                    <div className="empty-state-eventos">
                        <i className="bi bi-bell-slash"></i>
                        <h5>Nada para configurar</h5>
                        <p>Tu rol no tiene notificaciones configurables en este momento.</p>
                    </div>
                ) : (
                    <div style={{ maxWidth: 640 }}>
                        {tiposEmail.length > 0 && (
                            <div className="mb-4">
                                <h4 style={{ color: '#0075be', borderBottom: '2px solid #0075be', paddingBottom: '5px', marginBottom: '15px' }}>
                                    <i className="bi bi-envelope me-2"></i>EMAIL (Global)
                                </h4>
                                <p style={{ fontSize: '0.85rem', color: '#666', marginBottom: '15px' }}>
                                    Estos interruptores apagan o encienden el envío de correos automáticos para <strong>todos los clientes</strong> del sistema.
                                </p>
                                {tiposEmail.map((t) => (
                                    <div
                                        key={t.tipo}
                                        style={{
                                            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                            padding: '14px 4px', borderBottom: '1px solid #eee',
                                        }}
                                    >
                                        <span style={{ fontSize: '0.95rem', fontWeight: t.isGlobal ? 'bold' : 'normal' }}>{t.label}</span>
                                        <div className="form-check form-switch" style={{ margin: 0 }}>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                id={`pref-${t.tipo}`}
                                                checked={t.habilitado}
                                                disabled={guardando === t.tipo}
                                                onChange={() => toggle(t.tipo)}
                                                style={{ cursor: 'pointer' }}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        {tiposInApp.length > 0 && (
                            <div className="mb-4">
                                <h4 style={{ color: '#0075be', borderBottom: '2px solid #0075be', paddingBottom: '5px', marginBottom: '15px' }}>
                                    <i className="bi bi-app-indicator me-2"></i>IN-APP (Personal)
                                </h4>
                                <p style={{ fontSize: '0.85rem', color: '#666', marginBottom: '15px' }}>
                                    Estos interruptores controlan las notificaciones que te llegan a <strong>vos</strong> dentro de la plataforma.
                                </p>
                                {tiposInApp.map((t) => (
                                    <div
                                        key={t.tipo}
                                        style={{
                                            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                            padding: '14px 4px', borderBottom: '1px solid #eee',
                                        }}
                                    >
                                        <span style={{ fontSize: '0.95rem' }}>{t.label}</span>
                                        <div className="form-check form-switch" style={{ margin: 0 }}>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                id={`pref-${t.tipo}`}
                                                checked={t.habilitado}
                                                disabled={guardando === t.tipo}
                                                onChange={() => toggle(t.tipo)}
                                                style={{ cursor: 'pointer' }}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ConfiguracionNotificacionesPage;
